import pick from 'lodash/pick';

import {FeatureFlagApiPayload, FeatureFlagApiResponse} from 'app_api/projects/feature_flags/types';

export function payloadParamsFromModel(featureFlag: FeatureFlagApiResponse): FeatureFlagApiPayload {
  return pick(featureFlag, [
    `context`,
    `description`,
    `experiment_id`,
    `key`,
    `name`,
    `ruleset`,
    `serving_method`,
    `status`,
    `tags`,
  ]);
}
